import { memo } from 'react'

import TooltipInputError from '../toolTip/ToolTipInputError'
import { TextField, FormControl } from '@material-ui/core'

import { DOC_TYPES_LENGTH, PROVIDER_PC_ID } from 'utils/constants'

const NO_VALID_NUMBER = 'El Número de Identificación ingresado no es válido'
export const WRONG_CHARACTER = 'El Tipo de Datos ingresado No es válido.'
export const INVALID_LENGTH_MESSAGE = 'El Número de Caracteres NO es válido.'
export const REQUIRED_FIELD = 'El campo Número de Identificación es Obligatorio.'
export const CC_SPECIAL_MESSAGE = `${NO_VALID_NUMBER}: si tiene 10 dígitos, debe iniciar con 1 o 2.`
export const TI_SPECIAL_MESSAGE = `${NO_VALID_NUMBER}: para tipo Tarjeta de Identidad, no puede iniciar con 0.`

const getFirstDigit = formValue => formValue?.[0]
const isTI = documentType => documentType == 'TI'
const itStartsWith1or2 = formValue => ['1', '2'].includes(getFirstDigit(formValue))
const wrongLengthValidation = (formValueLength, minLength, maxLength) =>
   formValueLength < minLength || formValueLength > maxLength

//errorMessageLogiValidationMessages
export const customTIValidation = (documentType, formValue) => isTI(documentType) && getFirstDigit(formValue) == '0'
export const customCCValidation = (documentType, formValue, maxLength = DOC_TYPES_LENGTH['CC'][1]) =>
   [9, 'CC'].includes(documentType) && formValue?.length == maxLength && !itStartsWith1or2(formValue)

const customErrorMessage = (documentType, formValue, minLength, maxLength) => {
   const formValueLength = formValue?.length
   let message = ''
   if (customCCValidation(documentType, formValue)) message = CC_SPECIAL_MESSAGE
   else if (customTIValidation(documentType, formValue)) message = TI_SPECIAL_MESSAGE
   else if (wrongLengthValidation(formValueLength, minLength, maxLength)) message = INVALID_LENGTH_MESSAGE
   else message = WRONG_CHARACTER
   return message
}

function DocumentNumberField({
   fieldLabel = 'Número de identificación *',
   fieldName = 'documentNumber',
   formValue = '',
   fieldInvalid,
   handleChange,
   documentType,
   disabled,
   ...otherProps
}) {
   const [minLength, documentNumberSize = 10] = DOC_TYPES_LENGTH?.[documentType] ?? []

   return (
      <FormControl fullWidth {...otherProps}>
         <TextField
            error={fieldInvalid}
            value={formValue}
            onChange={e => {
               const { value } = e.target
               const parsedValue = ['NI', 'CC', 'PC', PROVIDER_PC_ID].includes(documentType) ? value.replace(/[^0-9]/g, '') : value
               handleChange({
                  target: {
                     name: fieldName,
                     value: parsedValue
                  }
               })
            }}
            disabled={documentType === '' || disabled}
            label={fieldLabel}
            name={fieldName}
            type="text"
            inputProps={{ maxLength: documentNumberSize + 1 }}
            InputProps={{
               endAdornment: formValue?.length === documentNumberSize + 1 && (
                  <TooltipInputError title={`El número permitido de caracteres es de máximo ${documentNumberSize}.`} />
               )
            }}
            helperText={
               <span style={{ lineHeight: 1 }}>
                  {fieldInvalid
                     ? !formValue?.length
                        ? REQUIRED_FIELD
                        : customErrorMessage(documentType, formValue, minLength, documentNumberSize)
                     : ''}
               </span>
            }
            size="small"
            variant="outlined"
            margin="normal"
         />
      </FormControl>
   )
}

export default memo(DocumentNumberField)
